module.exports = __webpack_public_path__ + "static/media/app-store.9166dbf2.svg";